// @react
import React, { ReactElement } from 'react'
// @types
import { GetUserQuery, GetUserQueryVariables } from 'lib/graphql/graphqlTypes'
// @graphQL
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
// @components
import ContactForm from 'modules/onBoarding/components/Contact/Form'
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 *
 * @constructor
 */
const ContactContainer = (): ReactElement => {
  /****************************************
   *  GQL HOOKS
   ****************************************/

  const {
    loading: isLoading,
    error: isError,
    data: userData,
    refetch,
  } = useQuery<GetUserQuery, GetUserQueryVariables>(GET_USER, {
    fetchPolicy: 'cache-first',
  })

  /******************************************
   * RENDER
   ******************************************/

  if (isError && !isLoading && !userData) return <QueryError />

  return <ContactForm data={userData} isLoading={isLoading} refetch={refetch} />
}

export default ContactContainer
